import { FormattedMessage } from "react-intl";

import { Button } from "@ps-design-system/components/Button";
import { Divider } from "@ps-design-system/components/Divider";
import { Form } from "@ps-design-system/components/Form";
import { Text } from "@ps-design-system/components/Text";

import type { Listing } from "../../../../../types/listings.types";
import { useListingRulesForm } from "../useListingRulesForm";

import { GeneralRulesField } from "./form-fields/GeneralRulesField";
import { MaxGuestsField } from "./form-fields/MaxGuestsField";
import { MinAgeField } from "./form-fields/MinAgeField";
import { MinimumDurationField } from "./form-fields/MinimumDurationField";

type ListingRulesFormProps = {
  listing: Listing;
};

const ListingRulesForm = ({ listing }: ListingRulesFormProps) => {
  const { form, onSave, errorMsg } = useListingRulesForm(listing);

  const handleSave = async () => {
    const success = await onSave();
    if (success) {
      window.location.href = `/mylistings/${listing._id}`;
    }
  };

  return (
    <Form {...form}>
      <GeneralRulesField />
      <MinAgeField />
      <MinimumDurationField />
      <MaxGuestsField />

      <Divider />

      <div className="tw-flex tw-mt-32 tw-justify-end">
        <div className="tw-flex tw-flex-col tw-self-end tw-gap-8">
          <Button
            appearance="purple"
            disabled={!form.formState.isDirty}
            onClick={handleSave}
            showSpinner={form.formState.isSubmitting}
            testId="rules-form-save-button"
            className="tw-ml-auto"
          >
            <FormattedMessage
              id="hosting.listing_rules.save_button"
              defaultMessage="Save"
            />
          </Button>
          {errorMsg && (
            <Text
              typeface="body-1"
              element="p"
              className="tw-text-red-800"
              testId="rules-form-submit-error"
            >
              {errorMsg}
            </Text>
          )}
        </div>
      </div>
    </Form>
  );
};

export { ListingRulesForm };
